<template>
  <div class="column_public">
    <div class="sticky-block">
      <div v-if="contactPerson" class="info-block">
        <h5 class="title_public">{{ $t('Contact person') }}</h5>
        <div class="person-card">
          <img v-if="contactAvatar" :src="contactAvatar" loading="lazy" alt="" class="avatar" />
          <div>
            <div v-if="contactName">{{ contactName }}</div>
            <div v-if="contactPosition" class="text-secondary">
              {{ contactPosition }}
            </div>
          </div>
        </div>
        <div class="contact-block">
          <a
            v-if="contactEmail"
            :href="`mailto:${contactEmail}`"
            class="contact-item w-inline-block"
          >
            <div class="icon-20 w-embed">
              <MailIcon class="grey-500-icon" />
            </div>
            <div>{{ contactEmail }}</div>
          </a>
          <a
            v-if="contactPhoneNumber"
            :href="`tel:${contactPhoneNumber}`"
            class="contact-item w-inline-block"
          >
            <div class="icon-20 w-embed">
              <PhoneIcon class="grey-500-icon" />
            </div>
            <div>{{ contactPhoneNumber }}</div>
          </a>
          <Button
            class="contact-block__question"
            type="secondary"
            size="small"
            icon="message"
            @click="signUp"
          >
            {{ $t('Ask question online') }}
          </Button>
        </div>
      </div>
      <div class="div"></div>
      <div class="info-block">
        <h5 class="title_public">{{ $t('If you need help') }}</h5>
        <div class="person-card">
          <img src="/images/fix-logo.png" loading="lazy" alt="" class="avatar" />
          <div>
            <div>{{ $t('Fixtender support') }}</div>
            <div class="text-secondary">
              <span class="link" @click="openSupportChat">{{ $t('Open chat') }}</span> ·
              <span>{{ supportPhone }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="div"></div>
      <div class="info-block">
        <h5 class="title_public">{{ $t('Bill of quantities') }}</h5>
        <DownloadFile
          class="public-file"
          :file="{ name: offerXlsxTemplateFilename }"
          :is-extended="true"
          :is-loading="loadings.includes('offerXlsxTemplate')"
          trigger-download-in-parent
          @download="handleDownloadInParent"
        />
      </div>
      <div v-if="get(publicTenderInfo, 'files.length')" class="d-contents">
        <div class="div"></div>
        <div class="info-block">
          <h5 class="title_public">{{ $t('Attached files') }}</h5>
          <div class="files-wrap">
            <DownloadFile
              v-for="file in publicTenderInfo.files"
              :key="file.id"
              :file="file"
              :is-extended="true"
              class="public-file"
            />
          </div>
        </div>
        <div class="inline-wrap">
          <Button
            icon="download"
            size="small"
            type="secondary"
            @click.native.stop="downloadAllFilesHandler('downloadAll')"
          >
            <Spinner v-if="loadings.includes('downloadAll')" size="16" />
            <span v-else>{{ $t('Download all') }}</span>
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex';
  import MailIcon from '@/assets/icons/mail.svg';
  import PhoneIcon from '@/assets/icons/phone.svg';
  import DownloadFile from '@/components/files/DownloadFile';
  import { openSupportChat } from '@/integrations';
  import get from 'lodash.get';
  import Button from '@/components/ui-v2/Button';
  import Spinner from 'vue-simple-spinner';

  export default {
    name: 'RightColumnOfPublicTender',
    components: {
      MailIcon,
      PhoneIcon,
      DownloadFile,
      Button,
      Spinner,
    },
    computed: {
      ...mapState('global', ['supportPhone']),
      ...mapState('publicTender', [
        'contactPerson',
        'loadings',
        'publicTenderInfo',
        'offerXlsxTemplateFilename',
      ]),
      ...mapGetters('publicTender', [
        'contactName',
        'contactPhoneNumber',
        'contactEmail',
        'contactPosition',
        'contactAvatar',
      ]),
    },
    methods: {
      get,
      openSupportChat,
      ...mapActions('publicTender', ['downloadAllFilesHandler', 'downloadXlsxHandler']),
      async signUp() {
        await this.$router.push({
          name: 'login',
        });
      },
      handleDownloadInParent() {
        this.downloadXlsxHandler({
          loadingId: 'offerXlsxTemplate',
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/pages/public-tender';
  .public-file {
    max-width: 100%;
  }
</style>
